import { defineStore } from 'pinia'

interface ResidentState {
  isResident: boolean
}
interface ResidentActions {
  setResident: (newResident: boolean) => void
  getResident: () => boolean
}

export const useResidentStore = defineStore<
  'isResident',
  ResidentState,
  Record<string, never>,
  ResidentActions
>({
  id: 'isResident',
  state: (): ResidentState => ({
    isResident: false,
  }),
  actions: {
    setResident(newResident: boolean) {
      this.isResident = newResident
    },
    getResident(): boolean {
      return this.isResident
    },
  },
})
